import React, { useMemo } from 'react';
import { Box } from '@wix/design-system';
import { TwoColumnLayout } from '../../../components/layouts';
import { CreditCardSmall, DesignSparklesSmall, MobileSmall, SiteContentSmall } from '@wix/wix-ui-icons-common';
import { useStoreNameData } from '../context/storeNameAtoms';
import { StoreNameMain } from './StoreNameMain';
import { StoreNameSide } from './StoreNameSide';
import { useStoreLaunch } from '../hooks/useStoreLaunch';
import { TwoColumnProgressBar } from '../../../components/TwoColumnProgressBar/TwoColumnProgressBar';
import { Step } from '../../../components/TwoColumnProgressBar/components/StepsList/StepsList';

const getLoaderSteps = (isShowPayments: boolean): Step[] => {
  const steps: Step[] = [
    {
      label: 'CREATING_YOUR_SITE',
      description: 'CREATING_YOUR_SITE_DESCRIPTION',
      icon: <SiteContentSmall />,
      color: '#00C853',
    },
    {
      label: 'OPTIMIZE_TO_MOBILE',
      description: 'OPTIMIZE_TO_MOBILE_DESCRIPTION',
      icon: <MobileSmall />,
      color: '#2196F3',
    },
    {
      label: 'APPLYING_THEME',
      description: 'APPLYING_THEME_DESCRIPTION',
      icon: <DesignSparklesSmall />,
      color: '#9C27B0',
    },
  ];

  if (isShowPayments) {
    steps.push({
      label: 'CONNECTING_PAYMENTS',
      description: 'CONNECTING_PAYMENTS_DESCRIPTION',
      icon: <CreditCardSmall />,
      color: '#FF9800',
    });
  }
  return steps;
};

export function StoreName() {
  const { isAcceptedPayments, launchStatus } = useStoreNameData();
  const { onComplete } = useStoreLaunch();

  const steps = useMemo(() => getLoaderSteps(isAcceptedPayments), [isAcceptedPayments]);

  if (launchStatus !== 'idle') {
    return (
      <Box align="center" height="100%" width="100%">
        <TwoColumnProgressBar steps={steps} onComplete={onComplete} isLoading={launchStatus !== 'completed'} />
      </Box>
    );
  }

  return (
    <TwoColumnLayout
      mainContent={<StoreNameMain />}
      sideContent={<StoreNameSide />}
      mainContentSpan={6}
      sideCellStyle={{ maxWidth: '550px' }}
    />
  );
}
